var map = {
	"./01-mexican.svg": "3dbf",
	"./02-man.svg": "fe2b",
	"./03-pirates.svg": "5212",
	"./04-girl.svg": "8a0b",
	"./05-boy.svg": "117d",
	"./06-chinese.svg": "97cf",
	"./07-man.svg": "fc85",
	"./08-police.svg": "7d15",
	"./09-french.svg": "6c0c",
	"./10-girl.svg": "b11e",
	"./11-girl.svg": "2d02",
	"./12-arab.svg": "c986",
	"./13-rock.svg": "948b",
	"./14-boy.svg": "9b84",
	"./15-chinese.svg": "419b",
	"./16-girl.svg": "a1ab",
	"./17-nun.svg": "ff02",
	"./18-baby.svg": "e618",
	"./19-vietnam.svg": "71b7",
	"./20-clown.svg": "e44d",
	"./21-indian.svg": "9f6c",
	"./22-portuguese.svg": "47a7",
	"./23-oldster.svg": "e63c",
	"./24-girl.svg": "9a70",
	"./25-armenian.svg": "c648",
	"./26-japan.svg": "fc7d",
	"./27-ninja.svg": "f8c3",
	"./28-soldier.svg": "8375",
	"./29-girl.svg": "c599",
	"./30-viking.svg": "a1c1",
	"./31-boy.svg": "e67c",
	"./32-arab.svg": "d6da",
	"./33-indian.svg": "89d8",
	"./34-oldster.svg": "d99b",
	"./35-armenian.svg": "9622",
	"./36-user.svg": "84bd",
	"./37-dj.svg": "087e",
	"./38-girl.svg": "aa62",
	"./39-girl.svg": "9105",
	"./40-safari.svg": "3b36",
	"./41-cowboy.svg": "efe2",
	"./42-boy.svg": "9c5d",
	"./43-santaclause.svg": "6fa4",
	"./44-native.svg": "3260",
	"./45-doctor.svg": "973f",
	"./46-russia.svg": "d09c",
	"./47-scientist.svg": "c5ca",
	"./48-girl.svg": "9495",
	"./49-bellboy.svg": "89fc",
	"./50-king.svg": "749d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9210";